<template>
  <div>
    <parametre-generique
      :permsParametre="permsCompetenceFournisseur"
      :typeParametre="parametreCompetenceFournisseur"/>
  </div>
</template>

<script>

import { COMPETENCE_FOURNISSEUR } from '@/configuration/general/permissionsParametrageConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import parametreGenerique from '@/components/general/parametreGenerique';

export default {
  data() {
    return {
      permsCompetenceFournisseur: COMPETENCE_FOURNISSEUR,
      parametreCompetenceFournisseur: PARAMETRES_KEYS.competenceFournisseur,
    };
  },
  components: {
    parametreGenerique,
  },
  mounted() {
    this.setInformationPage(this.$t('pageParametrage.competenceFournisseur.liste'));
  },
};

</script>
